export { syncRevisedEcoeDelayedReasonVisibility } from "../columnVisibilityUtils";

export const defaultNonVisibleColumnsArray = [
 "buyerAddress",
 "closeOfEscrowActual",
 "closingAptTime",
 "closingDocsSent",
 "coBroker",
 "conciergeEmail",
 "conciergeName",
 "constructionManager",
 "contactMethod",
 "contingent",
 "contingentType",
 "electricity",
 "estimatedDeliverableDate",
 "extPkg",
 "finalSalesPrice",
 "finalSignOff",
 "flooring",
 "gas",
 "homesiteAddress",
 "homesitePhase",
 "homeToCloseDate",
 "homeToSell",
 "intPkg",
 "lastContact",
 "loanApprovalSF",
 "loanConditionalApproval",
 "loanDeclined",
 "loanForeignNationalLoan",
 "loanGrade",
 "loanLockExpirationDate",
 "loanOfficerEmail",
 "loanOfficerName",
 "loanSigning",
 "loanStatus",
 "mortgageType",
 "NHCDateTime",
 "NHADate",
 "nhcEmail",
 "optionIncentive",
 "oslLoanGrade",
 "osls/0/approval",
 "osls/0/condApproval",
 "osls/0/email",
 "osls/0/lockExpiery",
 "osls/0/name",
 "osls/0/phone",
 "osls/0/status",
 "osls/0/type",
 "osls/1/approval",
 "osls/1/condApproval",
 "osls/1/email",
 "osls/1/lockExpiery",
 "osls/1/name",
 "osls/1/phone",
 "osls/1/status",
 "osls/1/type",
 "ostName",
 "ostEmail",
 "paymentsCollected",
 "paymentsRemaining",
 "planDescription",
 "planNumber",
 "preConstruction",
 "preDrywall",
 "qaManager",
 "qaWalkDate",
 "realtorEmail",
 "realtorName",
 "revisedEcoe",
 "delayedReason",
 "revenueSubtotal",
 "solarType",
 "totalOptions",
 "totalPrice",
 "trenchDate",
 "water",
 "loanComment",
 "closeOfEscrowEstimatedMortgage",
 "loanGradeSFMortgage",
 "propertyAppraisalOrderDate",
 "propertyAppraisalReceiveDate",
 "cdApprovedDate",
 "loanClosingDate",
 "titleCompany",
 "revisedTitleCompany",
 "escrowClosingDate",
 "escrowOfficer",
 "loanProcessorName",
 "lennarTrackConsent",
 "packageDeliveredToLender",
 "lenderDocsReceived",
 "homeToClose",
];